import hex from 'crypto-js/enc-hex'
import sha1 from 'crypto-js/sha1'
import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root'
})
export class PasswordService {
    /**
     * Do not CHANGE, it effects password hashed send to backend!
     * @type {string}
     */
    private salt = 'assets'

    getPasswordStrengthError(): string {
        return 'Zadané heslo je příliš slabé! Heslo musí mít alespoň 8 znaků.'
    }

    getPasswordStrengthErrorHint(): string {
        return 'Heslo musí obsahovat alespoň 8 znaků.'
    }

    hashPassword(password, username): string {
        const toHash = username + this.salt + password
        return hex.stringify(sha1(toHash))
    }

    checkPasswordStrength(password): boolean {
        return typeof password === 'string' && password?.length >= 8
    }
}
